<template>
  <div
    class="widget-container"
    :class="{ 'new-design': $store.infoscreenData.useNewTemplateDesign }"
    :style="{ backgroundColor: currentPlaylistItem && (currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.WEATHER_WIDGET || currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.TEXT_WIDGET) ? 'rgba(0, 0, 0, 0.4)' : 'transparent' }"
  >
    <template v-if="playlist && currentPlaylistItem">
      <iframe
        v-if="currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.LINK"
        class="playlist-media__iframe"
        :src="currentPlaylistItem.media.link"
        scrolling="no"
      />

      <div
        v-else-if="currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.IMAGE"
        class="playlist-media__image"
        :style="{ backgroundImage: 'url(' +currentPlaylistItem.media.file.file_url + ')' }"
      />

      <div
        :class="[currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.AUDIO ? 'playlist-item_visible': 'playlist-item_invisible']"
        class="playlist-media__audio"
      >
        <svg
          width="228"
          height="228"
          viewBox="0 0 228 228"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M190 28.5V161.5C189.998 169.865 187.236 177.995 182.143 184.63C177.05 191.266 169.909 196.035 161.829 198.198C153.749 200.362 145.181 199.799 137.453 196.597C129.726 193.395 123.271 187.732 119.089 180.488C114.907 173.243 113.233 164.821 114.326 156.528C115.418 148.235 119.216 140.534 125.132 134.62C131.047 128.705 138.748 124.908 147.041 123.816C155.334 122.725 163.756 124.4 171 128.582V47.5H85.5001V161.5C85.4982 169.865 82.7364 177.995 77.6429 184.63C72.5495 191.266 65.4091 196.035 57.329 198.198C49.2489 200.362 40.6807 199.799 32.9532 196.597C25.2256 193.395 18.7705 187.732 14.589 180.488C10.4074 173.243 8.73305 164.821 9.82557 156.528C10.9181 148.235 14.7164 140.534 20.6315 134.62C26.5466 128.705 34.2479 124.908 42.5411 123.816C50.8343 122.725 59.256 124.4 66.5001 128.582V28.5H190ZM47.5001 180.5C52.5392 180.5 57.3719 178.498 60.9351 174.935C64.4983 171.372 66.5001 166.539 66.5001 161.5C66.5001 156.461 64.4983 151.628 60.9351 148.065C57.3719 144.502 52.5392 142.5 47.5001 142.5C42.4609 142.5 37.6282 144.502 34.065 148.065C30.5018 151.628 28.5001 156.461 28.5001 161.5C28.5001 166.539 30.5018 171.372 34.065 174.935C37.6282 178.498 42.4609 180.5 47.5001 180.5ZM152 180.5C157.039 180.5 161.872 178.498 165.435 174.935C168.998 171.372 171 166.539 171 161.5C171 156.461 168.998 151.628 165.435 148.065C161.872 144.502 157.039 142.5 152 142.5C146.961 142.5 142.128 144.502 138.565 148.065C135.002 151.628 133 156.461 133 161.5C133 166.539 135.002 171.372 138.565 174.935C142.128 178.498 146.961 180.5 152 180.5Z"
            fill="white"
          />
        </svg>
        <audio
          ref="audio"
        />
      </div>

      <video
        id="video1"
        ref="video1"
      />

      <video
        id="video2"
        ref="video2"
      />

      <WeatherWidget
        v-if="hasWeatherWidget"
        :class="[currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.WEATHER_WIDGET ? 'playlist-item_visible': 'playlist-item_invisible']"
        class="widget"
        :style="{backgroundColor: 'rgba(0, 0, 0, 0.3)'}"
      />

      <TextWidget
        v-if="hasTextWidget"
        :class="[currentPlaylistItem.mediaType === PLAYLIST_ITEM_TYPE.TEXT_WIDGET ? 'playlist-item_visible': 'playlist-item_invisible']"
        class="widget"
        :title="currentPlaylistItem.widgetMeta ? currentPlaylistItem.widgetMeta.title : ''"
        :description="currentPlaylistItem.widgetMeta ? currentPlaylistItem.widgetMeta.text : ''"
      />
    </template>
  </div>
</template>

<script>
import PlaylistMixin from '../mixins/PlaylistMixin';
import WeatherWidget from '../components/widgets/WeatherWidget';
import TextWidget from '../components/widgets/TextWidget';
import PLAYLIST_TYPE from '../constants/PlaylistType';
import PLAYLIST_ITEM_TYPE from '../constants/PlaylistItemType';

export default {
  name: 'PlaylistFrame',
  components: {
    WeatherWidget,
    TextWidget,
  },
  mixins: [PlaylistMixin],
  data() {
    return {
      PLAYLIST_ITEM_TYPE: PLAYLIST_ITEM_TYPE,
      videos: [],
      updatePlaylistTimeout: null,
      isFirstVideoTagEnabled: true,
      skipTimeout: null,
      itemHandlers: {
        [PLAYLIST_ITEM_TYPE.VIDEO]: this.handleVideoPlay,
        [PLAYLIST_ITEM_TYPE.AUDIO]: this.handleAudioPlay,
      },
      hasWeatherWidget: false,
      hasTextWidget: false,
    }
  },
  computed: {
    isMuted() {
      return !this.$store.deviceStartData.is_sound_enabled || this.$store.infoscreenData.ticketIsCalling || this.$store.infoscreenData.externalSoundIsCalling;
    },
    playlistItems() {
      if (!this.playlist || !Array.isArray(this.playlist.items)) return [];

      return this.playlist.items.filter(item => {
        item.mediaType = this.getMediaType(item);

        if (!item.mediaType) return false;

        if (item.mediaType === PLAYLIST_ITEM_TYPE.AUDIO && this.playlistType === PLAYLIST_TYPE.ADDITIONAL) return false;
        if (item.mediaType === PLAYLIST_ITEM_TYPE.VIDEO) this.videos.push(item);
        if (item.mediaType === PLAYLIST_ITEM_TYPE.WEATHER_WIDGET) this.hasWeatherWidget = true;
        if (item.mediaType === PLAYLIST_ITEM_TYPE.TEXT_WIDGET) this.hasTextWidget = true;
        return true;
      });
    },
    isOtherPlaylistPlaylingSound() {
      return (this.playlistType === 'main')
        ? this.$store.infoscreenData.isAdditionalPlaylistPlaylingSound
        : this.$store.infoscreenData.isMainPlaylistPlaylingSound;
    },
    isPlaylistPlayingSound() {
      return (this.playlistType === 'main')
        ? this.$store.infoscreenData.isMainPlaylistPlaylingSound
        : this.$store.infoscreenData.isAdditionalPlaylistPlaylingSound;
    }
  },
  watch: {
    isMuted() {
      // console.log(`%cИзменился параметр isMuted: ${value}`, 'color: green;');
      this.checkVolume();
    }
  },
  destroyed() {
    if (this.updatePlaylistTimeout) clearTimeout(this.updatePlaylistTimeout);
    if (this.skipTimeout) clearTimeout(this.skipTimeout);
    this.videoProcessor && this.videoProcessor.destroy();
  },
  methods: {
    nextPlaylistItem() {
      clearTimeout(this.skipTimeout);
      this.currentPlaylistItem = { mediaType: 'unknow' };

      this.$nextTick(() => {
        this.muteAll();
        this.hideAll();
        this.currentPlaylistItemId = this.getNextPlaylistItemId();
        this.currentPlaylistItem = this.playlistItems[this.currentPlaylistItemId];

        if (!this.currentPlaylistItem && !this.playlistItems.length) return;

        if (this.itemHandlers[this.currentPlaylistItem.mediaType]) {
          this.itemHandlers[this.currentPlaylistItem.mediaType](this.currentPlaylistItem);
        } else {
          const playlistItemDurationInMs = this.currentPlaylistItem.local_duration * 1000;

          this.updatePlaylistTimeout = setTimeout(
            () => this.nextPlaylistItem(),
            playlistItemDurationInMs
          );
        }
      });
    },
    hideAll() {
      this.hideElement(this.$refs.video1);
      this.hideElement(this.$refs.video2);
      this.hideElement(this.$refs.audio);
    },
    muteAll() {
      this.muteVideo(this.$refs.video1);
      this.muteVideo(this.$refs.video2);
      this.muteAudio(this.$refs.audio);
    },
    pauseMedia(media) {
      if (!media.paused) media.pause();
    },
    handleVideoPlay(playlistItem) {
      const nextVideo = this.getNextVideo(playlistItem);

      const currentVideoSrc = playlistItem.media.file.file_url;
      const nextVideoSrc = nextVideo.media.file.file_url;

      const playPromise = this.videoProcessor.play(currentVideoSrc, nextVideoSrc)

      if (playPromise !== undefined) {
        playPromise
          .catch((error) => {
            console.log(`%cОшибка при воспроизведении видео ${error}`, 'color: red');

            if (error.name !== 'NotAllowedError') {
              this.nextPlaylistItem();
            }
          });
      }
    },
    handleAudioPlay(playlistItem) {
      if (this.isOtherPlaylistPlaylingSound.enabled) {
        this.nextPlaylistItem();
        return;
      }

      this.audioProcessor.play(playlistItem.media.file.file_url);
    },
    hideElement(element) {
      element.classList.remove('playlist-item_visible');
      element.classList.add('playlist-item_invisible');
    },
    showElement(element) {
      element.classList.remove('playlist-item_invisible');
      element.classList.add('playlist-item_visible');
    },
    stopMedia(media) {
      media.pause();
      media.currentTime = 0;
    },
    getNextVideo(video) {
      const currentVideoIndex = this.videos.findIndex(item => item === video);
      const nextVideoIndex = currentVideoIndex + 1 < this.videos.length ? currentVideoIndex + 1 : 0;
      return this.videos[nextVideoIndex];
    },
    checkVolume() {
      for (const ref in this.$refs) {
        const mediaElement = this.$refs[ref];
        this.isMuted ? this.mute(mediaElement) : this.unmute(mediaElement);
      }
    },
    muteVideo(video) {
      video.muted = true;
      this.isPlaylistPlayingSound.enabled = false;
    },
    unmuteVideo(video) {
      if (!this.isMuted && !this.isOtherPlaylistPlaylingSound.enabled && !this.isPlaylistPlayingSound.enabled && this.playlistType !== PLAYLIST_TYPE.ADDITIONAL) {
        video.muted = false;
        this.isPlaylistPlayingSound.enabled = true;
        return true;
      }

      return false;
    },
    muteAudio(audio) {
      audio.muted = true;
      this.isPlaylistPlayingSound.enabled = false;
    },
    unmuteAudio(audio) {
      if (!this.isMuted && !this.isOtherPlaylistPlaylingSound.enabled && !this.isPlaylistPlayingSound.enabled) {
        audio.muted = false;
        this.isPlaylistPlayingSound.enabled = true;
      }
    },
    mute(mediaElement) {
      if (mediaElement instanceof HTMLVideoElement) {
        this.muteVideo(mediaElement);
      } else if (mediaElement instanceof HTMLAudioElement) {
        this.muteAudio(mediaElement);
      }
    },
    unmute(mediaElement) {
      if (!mediaElement.paused) {
        if (mediaElement instanceof HTMLVideoElement) {
          this.unmuteVideo(mediaElement);
        } else if (mediaElement instanceof HTMLAudioElement) {
          this.unmuteAudio(mediaElement);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-container {
  width: 100%;
  height: 100%;
  position: relative;

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
  }

  .widget {
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    background: black; // old infoscreen
  }

  &.new-design {
    video {
      background: transparent; // new infoscreen - no black background
      object-fit: cover; // new infoscreen
    }
  }
}

.playlist-item {
  &_visible {
    visibility: visible;
  }

  &_invisible {
    visibility: hidden;
  }
}

.playlist-media {
  &__image {
    background-size: contain; // old infoscreen
    background-repeat: no-repeat;
    background-position: center;
  }
}

.widget-container.new-design {
  .playlist-media {
    &__image {
      background-size: cover; // new infoscreen
    }
  }

  &__iframe {
    border: none;
  }

  &__audio {
    display: flex;
    align-items: center;
    justify-content: center;

    audio {
      position: fixed;
      top: -9999px;
      left: -9999px;
      width: 0;
      height: 0;
    }
  }
}
</style>
